<script setup>
// Cadastros do modulo Atendimentos. Sairam de dentro do proprio modulo (que
// tinha uma agenda igual a Agenda, e confundia quem usa) e vieram para
// Configuracoes, que e onde mora cadastro e e area de administrador.
import { computed, markRaw, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import PractitionersTab from './PractitionersTab.vue';
import UserAgendasTab from './UserAgendasTab.vue';
import ServicesTab from './ServicesTab.vue';
import HealthPlansTab from './HealthPlansTab.vue';
import ReasonsTab from './ReasonsTab.vue';

const { t } = useI18n();
const route = useRoute();
// As abas foram escritas para receber a conta por prop (antes viviam dentro de
// KanbanAppointments, que repassava). Sem isto, toda chamada ia para
// /accounts/undefined/... e a pagina abria vazia.
const accountId = computed(() => route.params.accountId);

const TABS = [
  {
    id: 'profissionais',
    labelKey: 'ATENDIMENTOS.tabs.profissionais',
    icon: 'i-lucide-users',
    comp: markRaw(PractitionersTab),
  },
  {
    id: 'agendas-usuarios',
    labelKey: 'ATENDIMENTOS.tabs.agendasUsuarios',
    icon: 'i-lucide-calendar-clock',
    comp: markRaw(UserAgendasTab),
  },
  {
    id: 'servicos',
    labelKey: 'ATENDIMENTOS.tabs.servicos',
    icon: 'i-lucide-briefcase',
    comp: markRaw(ServicesTab),
  },
  {
    id: 'parceiros',
    labelKey: 'ATENDIMENTOS.tabs.convenios',
    icon: 'i-lucide-shield',
    comp: markRaw(HealthPlansTab),
  },
  {
    id: 'motivos',
    labelKey: 'ATENDIMENTOS.tabs.configuracoes',
    icon: 'i-lucide-settings',
    comp: markRaw(ReasonsTab),
  },
];

const active = ref(TABS[0].id);
const activeComponent = computed(
  () => TABS.find(tab => tab.id === active.value)?.comp
);
</script>

<template>
  <div class="flex flex-col w-full h-full overflow-hidden">
    <div class="px-6 py-4 border-b border-n-slate-3">
      <h1 class="text-xl font-semibold tracking-[-0.02em] text-n-slate-12">
        {{ t('ATENDIMENTOS.settingsTitle') }}
      </h1>
      <p class="mt-1 text-sm text-n-slate-10">
        {{ t('ATENDIMENTOS.settingsSubtitle') }}
      </p>
    </div>

    <div class="flex items-center gap-1 px-6 py-2 border-b border-n-slate-3">
      <button
        v-for="tab in TABS"
        :key="tab.id"
        type="button"
        class="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-lg transition-colors"
        :class="
          active === tab.id
            ? 'bg-n-alpha-2 text-n-slate-12'
            : 'text-n-slate-10 hover:text-n-slate-12'
        "
        @click="active = tab.id"
      >
        <i :class="tab.icon" class="size-4" />
        {{ t(tab.labelKey) }}
      </button>
    </div>

    <div class="flex-1 min-h-0 overflow-y-auto">
      <component :is="activeComponent" :account-id="accountId" />
    </div>
  </div>
</template>
